import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "expense";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    expenseRecordList: {
      list: [],
      total: 0
    }
  },
  actions: {
    //1.费用记录相关操作
    //查询-
    async getExpenseRecordData({ commit }, payload) {
      let result = await api.get(
        `/api/CostManage?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setExpenseRecordList", result.data);
      }
      return result;
    },

    //添加
    async addExpenseRecord(a, payload) {
      let result = await api.post("/api/CostManage", payload);
      return result.data;
    },
    //删除整个单子数据
    async delExpenseRecordAll(a, payload) {
      let result = await api.delete(`/api/CostManage/` + payload);
      return result;
    },
    //删除单行数据
    async delExpenseRecord(a, payload) {
      let result = await api.delete(`/api/CostManage/Detail/` + payload);
      return result;
    },
    //编辑---获取单行数据
    async getEditExpenseRecord(a, payload) {
      let result = await api.get(`/api/CostManage/` + payload);
      return result.data;
    },
    //修改
    async updateExpenseRecord(a, payload) {
      let result = await api.put(`/api/CostManage`, payload);
      return result.data;
    },

    //2.费用名称相关操作
    //获取费用名称
    async getExpenseName({ commit }, payload) {
      let result = await api.get(
        `/api/CostSetting?name=${payload.name}&pid=${payload.pid}&versionType=1&type=${payload.type || ''}`
      );
      return result.data;
    },
    //删除费用名称
    async delExpenseName(a, payload) {
      console.log(payload);
      let result = await api.delete(`/api/CostSetting/${payload}`);
      return result.data;
    },
    //添加费用名称
    async addExpenseName(a, payload) {
      console.log(payload);
      let result = await api.post(`/api/CostSetting`, payload);
      return result;
    },
    //编辑获取费用名称
    async editExpenseName(a, payload) {
      let result = await api.get(`/api/CostSetting/` + payload);
      return result.data;
    },
    //修改费用名称
    async updateExpenseName(a, payload) {
      let result = await api.put(
        `/api/CostSetting/${payload.id}/${payload.name}/${payload.type}`
      );
      return result;
    },
    //费用分摊汇总表
    async getCostAllocationReport(a, payload) {
      let result = await api.get(
        `/api/CostAllocationReport?${queryString.stringify(payload)}`
      );
      return result.data;
    }
  },
  mutations: {
    setExpenseRecordList(state, payload) {
      state.expenseRecordList = payload;
    }
  },
  getters: {}
});

export default moduleName;
